var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgLocationinline = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 24,
  height: 24,
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M15 8a3 3 0 1 1-6 0 3 3 0 0 1 6 0Zm-1 0a2 2 0 1 1-4 0 2 2 0 0 1 4 0Z",
  fill: "#252829"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M21 8c0 2.943-6.362 12.247-8.388 15.136C12.228 23.683 12 24 12 24s-.228-.317-.612-.864C9.362 20.247 3 10.943 3 8c0-4.97 4.03-8 9-8s9 3.03 9 8ZM4 8c0-2.192.878-3.912 2.282-5.1C7.702 1.696 9.712 1 12 1c2.289 0 4.298.697 5.718 1.9C19.122 4.087 20 5.807 20 8c0 .26-.092.704-.326 1.35a20.4 20.4 0 0 1-.972 2.174c-.823 1.624-1.93 3.484-3.048 5.255A145.154 145.154 0 0 1 12 22.266c-.173-.247-.368-.53-.582-.84-.84-1.22-1.957-2.88-3.073-4.647-1.118-1.77-2.224-3.631-3.047-5.255a20.41 20.41 0 0 1-.971-2.173C4.092 8.704 4 8.259 4 8Z",
  fill: "#252829"
})));
export default SvgLocationinline;